import { useState } from "react";
import ExternalEditor from "./ExternalEditor";
import ExternalEditorHeader from "./ExternalEditorHeader";
import { useParams } from "react-router-dom";
import { languageType, CodeFile } from "utils/interfaces";

interface ExternalEditorEnvironmentProps {
  name: string;
  language: languageType | null;
  video: string;
  videoTranscript: string;
  pdf: string;
  AIAssistant: {
    name: string;
    img: string;
    greeting: string;
    intro: string;
  };
  fileState: CodeFile[];
}

const ExternalEditorEnvironment: React.FC<ExternalEditorEnvironmentProps> = ({
  name,
  language,
  video,
  videoTranscript,
  pdf,
  AIAssistant,
  fileState,
}) => {
  // States definition
  const [activeItem, setActiveItem] = useState<"editor" | "assistant">(
    "editor",
  ); // to change between editor and assistant views
  const [videoExpanded, setVideoExpanded] = useState(false);
  const [assistantPopupState, setAssistantPopupState] = useState<
    "closed" | "popup" | "popupNoCode" | "expanded" | "fullscreen"
  >("closed");

  // Get the url parameters
  const { moduleOrProject } = useParams();

  // Define the loaded state
  const loaded = name !== undefined && video !== undefined && !!moduleOrProject;

  return (
    <div className={`flex-grow relative`}>
      <div className="h-screen overflow-hidden">
        <ExternalEditorHeader
          name={name}
          language={language}
          AIAssistant={AIAssistant}
          activeItem={activeItem}
          setActiveItem={setActiveItem}
          showAssistant={
            !["Cultural Capabilities", "Video and PDF"].includes(
              language as string,
            )
              ? true
              : false
          }
          assistantPopupState={assistantPopupState}
          setAssistantPopupState={setAssistantPopupState}
          codeFiles={fileState}
          showExternalLink={
            !["Cultural Capabilities", "Video and PDF"].includes(
              language as string,
            )
              ? true
              : false
          }
        />
        {loaded && (
          <div className={videoExpanded ? "" : "relative"}>
            <ExternalEditor
              key={name}
              video={video}
              videoTranscript={videoTranscript}
              pdf={pdf}
              toShrink={videoExpanded}
              hide={activeItem === "assistant"}
            />
          </div>
        )}
      </div>
    </div>
  );
};
export default ExternalEditorEnvironment;
